


















































import Vue from 'vue';
import VerifyRequestViewModel from '@glittr/frontend-core/src/services/viewModel/request/Me/VerifyRequestViewModel';
import ResendVerificationCodeRequestViewModel from '@glittr/frontend-core/src/services/viewModel/request/Me/ResendVerificationCodeRequestViewModel';

export default Vue.extend({
  auth: true,
  layout: ['layout-exterior', '_exterior'],
  data: () => ({
    isLoading: false,
    requestError: undefined,
    requestInfo: undefined as string | undefined,
    verifyModel: new VerifyRequestViewModel(),
  }),
  methods:
    {
      async doVerify() {
        if (!this.verifyModel.validate()) {
          return;
        }
        this.isLoading = true;
        this.requestError = undefined;
        this.requestInfo = undefined;
        try {
          await this.$service.api.core.me.verify(this.verifyModel);
          await this.$auth.refresh();
          Vue.$router.replace('/');
        } catch (error: any) {
          this.requestError = error;
        }
        this.isLoading = false;
      },
      async doResendVerificationCode() {
        this.isLoading = true;
        this.requestInfo = undefined;
        this.requestError = undefined;
        const email = this.$auth.user?.email;
        try {
          const query = new ResendVerificationCodeRequestViewModel().fromModel({ email: email! });
          await this.$service.api.core.me.resendVerificationCode(query);
          this.requestInfo = this.$t('page.verifyUser.label.verificationCodeResent');
        } catch (error: any) {
          this.requestError = error;
        }
        this.isLoading = false;
      },
    },
});

